import { render, staticRenderFns } from "./AppScore.vue?vue&type=template&id=0774afca&scoped=true"
import script from "./AppScore.vue?vue&type=script&lang=ts"
export * from "./AppScore.vue?vue&type=script&lang=ts"
import style0 from "./AppScore.vue?vue&type=style&index=0&id=0774afca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0774afca",
  null
  
)

export default component.exports